import Animate, { AnimationTypes } from "../Animate/Animate"
import { useTranslation } from "react-i18next"
import type { InteractionDescriptionProps } from "../InteractionTooltip/InteractionTooltip"

interface SimpleToggleProps extends InteractionDescriptionProps {
  value: boolean
  title: string
  disabled?: boolean
  onChange: (value: boolean) => void
  delay?: string
  animationTypes?: keyof typeof AnimationTypes
  animationDuration?: string
  boxShadow?: string
}

export function SimpleToggle({
  title = "",
  value,
  onChange,
  delay = "0s",
  disabled,
  animationDuration = "1s",
  animationTypes = AnimationTypes.fadeInTraslate,
  boxShadow,
  descriptionKey,
}: SimpleToggleProps) {
  const { t } = useTranslation("interactionDescriptions")

  return (
    <Animate type={animationTypes} duration={animationDuration} delay={delay}>
      <div
        className="flex items-center gap-3 px-4 py-2 rounded-xl bg-white border-2 border-slate-200 transition-all duration-300"
        style={{ boxShadow }}
      >
        <span className="flex-1 min-w-0 text-sm font-semibold text-slate-700 ">{title}</span>

        <button
          data-interaction-description-key={descriptionKey}
          aria-label={t(descriptionKey)}
          type="button"
          onClick={() => onChange(!value)}
          disabled={disabled}
          className={`relative shrink-0 w-12 h-6 rounded-full transition-all duration-300 ${value ? "bg-gradient-to-r from-red-600 to-orange-500" : "bg-slate-300"}`}
        >
          <span
            className={`absolute top-1 left-1 w-4 h-4 rounded-full bg-white shadow-md transition-all duration-300 ${value ? "translate-x-6" : "translate-x-0"}`}
          />
        </button>
      </div>
    </Animate>
  )
}
